import { revalidateAndRedirect } from 'app/actions';
import { PropsWithChildren, createContext, useCallback, useContext } from 'react';

export default interface SafeNavigator {
  push: (url: string) => Promise<void>;
  replace: (url: string) => Promise<void>;
  refresh: () => Promise<void>;
}

const SafeNavigatorContext = createContext<SafeNavigator>({
  push: async () => {
    /* noop */
  },
  replace: async () => {
    /* noop */
  },
  refresh: async () => {
    /* noop */
  },
});

export function SafeNavigatorProvider({ children }: PropsWithChildren): JSX.Element {
  const push = useCallback(async (url: string) => {
    revalidateAndRedirect(url);
  }, []);
  const replace = useCallback(async (url: string) => {
    revalidateAndRedirect(url);
  }, []);
  const refresh = useCallback(async () => {
    revalidateAndRedirect(window.location.href);
  }, []);

  return (
    <SafeNavigatorContext.Provider value={{ push, replace, refresh }}>
      {children}
    </SafeNavigatorContext.Provider>
  );
}

/**
 * 안전한 네비게이터를 반환합니다.
 * 네비게이터의 Promise는 네비게이션 완료 후에 resolve 되는것을 보장합니다.
 * 단, resolve / reject 되는 시점은 이후 몇차례의 네비게이션 이벤트가 발생한 후 일 수 있습니다.
 *
 * @returns {SafeNavigator} navigator
 */
export function useSafeNavigator(): SafeNavigator {
  return useContext(SafeNavigatorContext);
}
